// P1-3: shared reduced-motion check — smooth scrolls in this file read this
// instead of hardcoding behavior:'smooth'.
function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// ===== NAV — 3-state scroll behavior =====
(function () {
    // Cached header/hero nodes. A customizer section edit replaces them with
    // fresh DOM (LESSONS 71), so the cache refreshes per section reload —
    // onScroll itself stays free of per-frame queries.
    let nav, brand, navLinks, heroEl, mobileBtn, cartBtn;
    function refresh() {
        nav = document.getElementById('main-nav');
        brand = document.getElementById('brand-mark');
        navLinks = document.querySelectorAll('#main-nav .nav-link');
        heroEl = document.querySelector('.hero');
        mobileBtn = document.getElementById('mobile-menu-btn');
        cartBtn = document.getElementById('nav-cart-btn');
    }

    function setNavState(state) {
        nav.classList.remove('nav-on-hero', 'nav-default', 'nav-scrolled');
        nav.classList.add(state);
        const onDark = (state === 'nav-on-hero');
        const linkColor = onDark ? '#FEFEFA' : '#1F1812';
        if (brand) brand.style.color = linkColor;
        navLinks.forEach(l => l.style.color = linkColor);
        if (mobileBtn) mobileBtn.style.color = linkColor;
        if (cartBtn) cartBtn.style.color = linkColor;
    }

    function onScroll() {
        if (!nav) return;
        const heroBottom = heroEl ? heroEl.getBoundingClientRect().bottom : 0;
        const y = window.scrollY;
        if (heroEl && heroBottom > 80) {
            setNavState('nav-on-hero');
        } else if (y > 40) {
            setNavState('nav-scrolled');
        } else {
            setNavState(heroEl ? 'nav-default' : 'nav-scrolled');
        }
    }
    refresh();
    if (!nav) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    // Scroll listener binds once; only the node cache refreshes per reload,
    // then state reapplies so the fresh nav doesn't sit in its server classes.
    document.addEventListener('shopify:section:load', () => { refresh(); onScroll(); });
})();

// ===== Mobile nav overlay =====
// #mobile-nav and both buttons live in the header section, so a customizer edit
// to the header replaces them with fresh nodes (LESSONS 71). open/close resolve
// their elements at call time, and wiring re-runs per section reload with a
// dataset.wired guard — same pattern as wireBios below.
(function () {
    // P2-4: Tab trap while the overlay is open (house pattern — cart-drawer.js focusable()).
    function focusable(overlay) {
        return Array.prototype.filter.call(
            overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
            (el) => !el.hidden
        );
    }
    // Dylan 2026-07-14: overlay is position:fixed/inset:0, so opening it while
    // the announcement bar is visible covered the bar, and the overlay's own
    // logo row jumped up to the very top of the viewport instead of lining up
    // with the real header (which sits below the bar). Read the bar's
    // currently-visible height on each open and offset the overlay's top edge
    // by that much — bottom clamped to 0 so a bar scrolled out of view (or a
    // removed section, see querySelector guard) doesn't push the overlay down.
    function announcementBarOffset() {
        const bar = document.querySelector('.announcement-bar');
        if (!bar) return 0;
        return Math.max(0, bar.getBoundingClientRect().bottom);
    }
    function open() {
        const overlay = document.getElementById('mobile-nav');
        if (!overlay) return;
        const openBtn = document.getElementById('mobile-menu-btn');
        const closeBtn = document.getElementById('mobile-menu-close');
        overlay.style.top = announcementBarOffset() + 'px';
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('nav-locked');
        if (closeBtn) closeBtn.focus();
    }
    function close() {
        const overlay = document.getElementById('mobile-nav');
        if (!overlay) return;
        const openBtn = document.getElementById('mobile-menu-btn');
        overlay.classList.remove('is-open');
        // Deliberately do NOT clear the announcement-bar offset here: the panel
        // stays visible through its 500ms opacity fade (homepage.css), so
        // resetting top mid-fade snaps it upward before it disappears. open()
        // recalculates the offset every time, so a stale value can't be seen.
        overlay.setAttribute('aria-hidden', 'true');
        if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
        document.body.classList.remove('nav-locked');
    }
    function wireMobileNav(root) {
        const openBtn = root.querySelector('#mobile-menu-btn');
        if (openBtn && !openBtn.dataset.wired) {
            openBtn.dataset.wired = '1';
            openBtn.addEventListener('click', open);
        }
        const closeBtn = root.querySelector('#mobile-menu-close');
        if (closeBtn && !closeBtn.dataset.wired) {
            closeBtn.dataset.wired = '1';
            closeBtn.addEventListener('click', close);
        }
        const overlay = root.querySelector('#mobile-nav');
        if (overlay) {
            overlay.querySelectorAll('a').forEach(a => {
                if (a.dataset.wired) return;
                a.dataset.wired = '1';
                a.addEventListener('click', close);
            });
        }
    }
    wireMobileNav(document);
    document.addEventListener('shopify:section:load', (e) => {
        wireMobileNav(e.target);
        // A reload can swap the overlay out from under an open menu; the fresh
        // one renders closed, so drop the body scroll lock the old one left.
        if (e.target.querySelector('#mobile-nav')) document.body.classList.remove('nav-locked');
    });
    // Bound once on document (survives section reloads); resolves the overlay
    // at event time instead of closing over a node a reload may have replaced.
    document.addEventListener('keydown', (e) => {
        const overlay = document.getElementById('mobile-nav');
        // gated on is-open so the added Tab trap doesn't hijack Tab site-wide
        if (!overlay || !overlay.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab') {
            const f = focusable(overlay);
            if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
    });
})();

// ===== Mobile second-level (tap "Classes" to reveal its sub-links) =====
// Tapping the parent toggles instead of navigating. The sub-links are absolutely
// positioned; on open we translate the whole group UP by their height so the rows
// below it don't shift down (Dylan).
// Re-runnable for the same header-reload reason as the overlay above.
(function () {
    function wireMnavGroups(root) {
        root.querySelectorAll('[data-mnav-group]').forEach((group) => {
            const toggle = group.querySelector('[data-mnav-toggle]');
            const subs = group.querySelector('[data-mnav-subs]');
            if (!toggle || !subs || toggle.dataset.wired) return;
            toggle.dataset.wired = '1';
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const open = group.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                group.style.transform = open ? `translateY(-${subs.offsetHeight}px)` : '';
            });
        });
    }
    wireMnavGroups(document);
    document.addEventListener('shopify:section:load', (e) => wireMnavGroups(e.target));
})();

// ===== Reveal on scroll =====
(function () {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));

    // Customizer hot-reload: when a section is re-rendered, the new DOM has
    // .reveal elements that the original IntersectionObserver never saw —
    // so they stay opacity:0. Force them visible on every section reload.
    document.addEventListener('shopify:section:load', (e) => {
        e.target.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
    });
})();

// ===== Bio read-more (team-grid person cards) =====
(function () {
    function wireBios(root) {
        root.querySelectorAll('.bio-toggle').forEach(btn => {
            if (btn.dataset.wired) return;
            btn.dataset.wired = '1';
            const bio = btn.previousElementSibling;
            if (!bio || !bio.classList.contains('bio-text')) return;
            // Hide toggle for short bios. Char count is more reliable than
            // measuring scrollHeight on a -webkit-line-clamp box.
            if ((bio.textContent || '').trim().length < 220) {
                btn.classList.add('is-hidden');
                return;
            }
            btn.addEventListener('click', () => {
                const expanded = bio.classList.toggle('expanded');
                btn.textContent = expanded ? 'Read less' : 'Read more';
            });
        });
    }
    wireBios(document);
    document.addEventListener('shopify:section:load', (e) => wireBios(e.target));
})();

// ===== Rich-text-image read-more toggle =====
(function () {
    function wireRichImageReadMore(root) {
        root.querySelectorAll('.rich-image-toggle').forEach(btn => {
            if (btn.dataset.wired) return;
            btn.dataset.wired = '1';
            const body = btn.previousElementSibling;
            if (!body || !body.classList.contains('rich-image-body--collapsible')) return;
            if ((body.textContent || '').trim().length < 280) {
                btn.style.display = 'none';
                return;
            }
            btn.addEventListener('click', () => {
                const expanded = body.classList.toggle('expanded');
                btn.textContent = expanded ? 'Read less' : 'Read more';
            });
        });
    }
    wireRichImageReadMore(document);
    document.addEventListener('shopify:section:load', (e) => wireRichImageReadMore(e.target));
})();

// ===== Testimonial slider =====
(function () {
    const slider = document.querySelector('[data-testimonial-slider]');
    if (!slider) return;

    const track = slider.querySelector('[data-track]');
    const slides = Array.from(slider.querySelectorAll('.testimonial-slide'));
    const dots = Array.from(slider.querySelectorAll('.testimonial-dot'));
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');
    let index = 0;

    const updateDots = (i) => {
        dots.forEach((d, idx) => {
            d.classList.toggle('is-active', idx === i);
            d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
    };
    const goTo = (i) => {
        index = ((i % slides.length) + slides.length) % slides.length;
        const target = slides[index];
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        updateDots(index);
    };
    const next = () => goTo(index + 1);
    const prev = () => goTo(index - 1);

    let scrollRaf = null;
    track.addEventListener('scroll', () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => {
            const left = track.scrollLeft;
            let closest = 0;
            let minDist = Infinity;
            slides.forEach((s, idx) => {
                const dist = Math.abs((s.offsetLeft - track.offsetLeft) - left);
                if (dist < minDist) { minDist = dist; closest = idx; }
            });
            if (closest !== index) { index = closest; updateDots(index); }
        });
    }, { passive: true });

    nextBtn && nextBtn.addEventListener('click', next);
    prevBtn && prevBtn.addEventListener('click', prev);
    dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.dot, 10))));

    updateDots(0);
})();

// Manifesto/spec rows: no scroll-driven highlight on mobile (tried, felt like
// the page was misfiring when the user wasn't looking there — removed 2026-06-03).
// Hover highlights are gated behind @media (hover: hover) in CSS instead.
